import { useLocation } from "react-router";
import { usePages } from "../../hooks/usePages";
import MobileNavLabel from "./mobile/mobileNavLabel";
import MobileNavStep from "./mobile/mobileNavStep";

const MobileNavBar = () => {
	const { pages } = usePages();
	const location = useLocation();

	return (
		<div className="bg-background-primary tablet:hidden m-6 flex justify-center text-center">
			<div className="flex w-full flex-col">
				<div className="flex w-full p-1">
					<MobileNavLabel pages={pages} />
				</div>
				<div className="border-background-secondary shadow-large flex w-full justify-between rounded-lg border border-solid p-1">
					{pages.map((page) => (
						<MobileNavStep
							key={page.url}
							isActive={location.pathname === page.url}
							isCompleted={page.isCompleted}
							hasWarning={page.hasWarning}
						/>
					))}
				</div>
			</div>
		</div>
	);
};

export default MobileNavBar;
